import { render, staticRenderFns } from "./historico.vue?vue&type=template&id=7023287c&scoped=true&"
import script from "./historico.vue?vue&type=script&lang=js&"
export * from "./historico.vue?vue&type=script&lang=js&"
import style0 from "./historico.vue?vue&type=style&index=0&id=7023287c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023287c",
  null
  
)

export default component.exports